import { toast } from "react-toastify";

/**
 * Set up Binance Smart Chain (BNB) network on MetaMask
 * @param {number} chainId - The chain ID to set up (e.g., 56 for BNB Mainnet)
 * @returns {boolean} true if the setup succeeded, false otherwise
 */
export const setupNetwork = async (targetChainId) => {
  const provider = window.ethereum;
  const chainId =
    typeof targetChainId === "number" && Number.isFinite(targetChainId)
      ? targetChainId
      : parseInt(process.env.REACT_APP_CHAIN_ID || "56", 10);
  const rpcUrl = process.env.REACT_APP_NODE_1 || "https://bsc.drpc.org";

  console.log("chainnnnnnnn idddd : ", chainId);

  if (!provider) {
    console.error(
      "MetaMask is not installed or `window.ethereum` is undefined."
    );
    toast.error("Metasm is not installed or `window.ethereum` is undefined");
    return false;
  }

  const networkParams = {
    // chainId: `0x${chainId.toString(16)}`, // Convert chainId to hexadecimal
    chainId: `0x${parseInt(chainId, 10).toString(16)}`, // Convert chainId to hexadecimal
    chainName: "Binance Smart Chain Mainnet",
    nativeCurrency: {
      name: "Binance Coin",
      symbol: "BNB",
      decimals: 18,
    },
    rpcUrls: [rpcUrl],
    blockExplorerUrls: ["https://bscscan.com"],
  };

  try {
    // Attempt to switch to the Binance Smart Chain network
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: networkParams.chainId }],
    });
    return true;
  } catch (error) {
    if (error?.code === 4001) {
      // user rejected request
      return false;
    }
    if (error.code === 4902) {
      // Network not found, add it
      try {
        await provider.request({
          method: "wallet_addEthereumChain",
          params: [networkParams],
        });
        return true;
      } catch (addError) {
        console.error("Failed to add Binance Smart Chain network:", addError);
        toast.error(
          "Failed to add Binance Smart Chain network, try adding it in wallet manually"
        );
      }
    } else {
      console.error("Failed to switch to Binance Smart Chain network:", error);
      toast.error(
        "Failed to switch to Binance Smart Chain network, try switching it in wallet manually"
      );
    }
  }

  return false;
};
